import React from 'react';
import { LANDING } from '@/constants/testIds';

const stats = [
    { id: LANDING.statExercises, value: '832+', label: 'Exercises in the Library' },
    { id: LANDING.statMeasurements, value: '12', label: 'Body Measurements Tracked' },
    { id: LANDING.statSections, value: '7', label: 'Sections of Fitness Data' },
];

export const StatsBar = () => {
    return (
        <section
            data-testid={LANDING.statsBar}
            className="relative border-y border-white/5 bg-black"
        >
            {/* Faint lime line above */}
            <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#b8ff00]/30 to-transparent" />

            <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 sm:py-16 grid grid-cols-1 sm:grid-cols-3 gap-10">
                {stats.map((s) => (
                    <div
                        key={s.id}
                        data-testid={s.id}
                        className="text-center group"
                    >
                        <div className="text-5xl sm:text-6xl font-extrabold text-[#b8ff00] font-display tracking-tight">
                            {s.value}
                        </div>
                        <div className="mt-2 text-sm text-[#8e8e93] uppercase tracking-[0.18em]">
                            {s.label}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default StatsBar;
